<script setup lang="ts">
import { useI18nLocalize } from '@/i18n/i18nLocalize';
import { useComponentComposable } from '@/components/useComponentComposable';

const props = defineProps<{
  tours: object;
  lang: string;
}>();

const { fallBackImage } = useComponentComposable();
const { i18nLocale } = useI18nLocalize();
const { $t } = i18nLocale(props.lang);

const openDetail = (link: string) => {
  location.href = link;
};
</script>
<template>
  <table>
    <thead>
      <tr>
        <th class="hidden"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="pt-2 vertical-align-top">
          <img :src="tours?.imageLink || fallBackImage" alt="" class="height-150px width-220px" />
        </td>
        <td class="client-copy-tour pl-3">
          <ul class="no-bullets">
            <li class="font-bold">
              <span v-if="tours.tourName">{{ tours.tourName }} - </span>
              <span>{{ tours.tourInclusion }}</span>
            </li>
            <li class="text-sm">
              <div class="font-italic">
                <span class="font-bold">{{ $t('management.tour.list_tour_detail.visited_cities') }}: </span>
                <span>{{ tours.visitedCities }}</span>
              </div>
            </li>
            <li class="my-4">
              <span class="font-bold mr-1">{{ $t('common.labels.type_of_tour') }} </span>
              <span v-if="tours.tourType">
                {{ tours.tourType }}
              </span>
              <span v-if="tours.tourType && tours.guided"> - </span>
              <span v-if="tours.guided">
                {{ tours.guided }}
              </span>
            </li>
            <li>
              <div class="text-sm my-4">{{ tours?.tourDescription }}</div>
              <div class="text-sm flex mb-4">
                <div class="link_detail cursor-pointer" @click="openDetail(tours?.tourLink)">{{ $t('worksheet.tour_detail') }}</div>
                <span class="ml-1">({{ $t('client_copy.open_link_detail') }})</span>
              </div>
            </li>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</template>
